export default __webpack_public_path__ + "static/media/blue-calender-icon.6231e246.svg";